export const BuffaloFAQ = () => {
    return (
        <>
            <p><strong>Reguli generale</strong></p>
            <span>Înregistrarea la Cursa Buffalo este gratuită, însă pentru a participa este necesar un cont activ și validat la Princess Casino.</span>
            <span>Aduni puncte pe baza rulajului realizat. 1 RON pariat = 1 punct. Pariurile trebuie realizate cu bani cash în perioada desfășurării competiției.</span>
            <span>Te rugăm să consulţi Termenii și Condițiile pentru regulile specifice aplicabile.</span>
            <p><strong>Cum câștig</strong></p>
            <span>Câştigătorii Cursei Buffalo sunt stabiliţi pe baza poziţiei unui jucător în Clasament la finalul cursei.</span>
            <span>Pariul minim pentru Cursa Buffalo este de 1 RON.</span>
            <span>Punctajul unui jucător este suma tuturor punctelor obținute la jocul eligibil, din pariuri realizate cu bani cash în perioada desfășurării competiției.</span>
            <p><strong>Ce câștig</strong></p>
            <span><strong>Premii în funcție de clasament</strong>: adună cât mai multe puncte și califică-te în topul cursei pentru un premiu în bani.</span>
            <span><strong>Premii bonus instant</strong>: adună minim 10 puncte într-o zi și zilnic ești eligibil pentru un premiu la 5 minute.</span>
            <span><strong>3 iPhone 13</strong>: câte un telefon iPhone 13 pe zi, acordat prin extragere la colectarea de minim 500 de puncte.</span>
        </>
    )
}